import { Loading } from '@components/Loading'

import { LoadingContainer } from './styles'

export function Loader() {
  return (
    <LoadingContainer>
      <Loading />
    </LoadingContainer>
  )
}
